const config: Record<any, any> = {
	lng: 'vi', //vi|en
	region: 'VI', //vi|pk
	version: '1',
	statusSuccess: 'successful',
	domain: 'aff.fconline.garena.vn',
	baseUrl: 'https://aff.fconline.garena.vn',
	downloadUrl: '',
	eventMsg: 'Sự kiện sẽ bắt đầu vào ngày 23.07.2026',
	shareHashtag: '#FCOnline #DonghanhAFF2026',
	shareQuote: '',
	predictGuide: 'https://',
	prizeListGlobal:
		'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2024/T9/EPL/epl_qua.png',
	guideImg:
		'https://cdn.vn.garenanow.com/web/fo4vn//Khoa/2024/T9/EPL/epl_hdc.png',
	arrPreloadImg: [
		'https://cdn.vn.garenanow.com/web/fo4vn/Khoa/2026/T1/TET/horse.webm',
	],
	lotteryTier: ['Giải đặc biệt', 'Giải nhất', 'Giải nhì', 'Giải ba', 'Giải tư', 'Giải năm', 'Giải sáu', 'Giải bảy', 'Giải tám', 'Giải chín', 'Giải mười']
};
export default config;
